$(document).ready(function() {
    var slideWidth = $(".slider-handle img").outerWidth(true);
    var slideCount = $(".slider-handle img").length;
    var slideTotalWidth = slideWidth * slideCount;
    var currentSlide = 0;
  
    // Function to update button states (prev/next)
    function updateButtonStates() {
      $(".prev").prop("disabled", currentSlide === 0);
      $(".next").prop("disabled", currentSlide === slideCount - 1);
    }
  
    // Call updateButtonStates initially to disable buttons for first load
    updateButtonStates();
  
    // Move to the next slide
    $(".next").click(function() {
      if (currentSlide < slideCount - 1) {
        currentSlide++;
        $(".slider-handle").animate({ scrollLeft: slideWidth * currentSlide }, 100);
        updateButtonStates(); // Update button states after slide change
      }
    });
  
    // Move to the previous slide
    $(".prev").click(function() {
      if (currentSlide > 0) {
        currentSlide--;
        $(".slider-handle").animate({ scrollLeft: slideWidth * currentSlide }, 100);
        updateButtonStates(); // Update button states after slide change
      }
    });
  
    $(".slider-handle img").click(function() {
      var link = $(this).attr('data-link');
      window.location.href = link;
    });
  });